import React from 'react';
import ReactTooltip from 'react-tooltip';
import { BaasicTable, Loader, BaasicSelect } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { translate } from 'core/utils';

const ExitScanModeTemplate = ({
	t,
	exitScanModeViewStore,
	exitScanModeViewStore: {
		form,
		fulfillmentOrders,
		tableData,
		exitScanNotification,
		onDetails,
		palletOptions,
		warehouseOptions,
		selectedPallet,
		setReference,
		loading,
		selectedWarehouse,
		onWarehouseChange,
		onChange,
		debouncedWarehouseSearch,
		debouncedSearch,
		isSeller,
		isSuperAdminOrganization,
		isWarehouseDropdownLoading,
		isPalletDropdownLoading,
		handleOnMenuScroll,
		onMenuClose,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="form" onSubmit={form.onSubmit}>
				<div>
					<div className="ReactModal__header">
						<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.EXITSCANMODE.TITLE')}</h3>
					</div>
					<div className="ReactModal__body">
						<div className="row">
							{(isSeller || isSuperAdminOrganization) && (
								<div className="col col-sml-12 col-med-6 col-lrg-4">
									<BaasicSelect
										autoFocus
										field={form.$('warehouse')}
										options={warehouseOptions.slice()}
										value={selectedWarehouse}
										isLoading={isWarehouseDropdownLoading}
										onChange={onWarehouseChange}
										validation={false}
										onMenuScrollToBottom={handleOnMenuScroll}
										onMenuClose={onMenuClose}
										onInputChange={debouncedWarehouseSearch}
										isClearable={true}
										reference={setReference}
										className="spc--bottom--sml flex--grow--1"
									/>
								</div>
							)}
							<div className="col col-sml-12 col-med-6 col-lrg-4">
								<BaasicSelect
									field={form.$('pallet')}
									isDisabled={isSeller && selectedWarehouse === null}
									clearable={false}
									value={selectedPallet}
									isLoading={isPalletDropdownLoading}
									onChange={onChange}
									options={palletOptions}
									onInputChange={debouncedSearch}
									validation={false}
									reference={setReference}
									className="spc--bottom--sml flex--grow--1"
								/>
							</div>
						</div>
						{form.error && !exitScanNotification && (
							<p className="type--color--warning spc--bottom--sml">{translate(form.error)}</p>
						)}
						{exitScanNotification && (
							<p
								className={
									exitScanNotification.includes('WARNING') ||
									exitScanNotification.includes('EMPTYPALLET') ||
									exitScanNotification.includes('NOTFOUND')
										? 'type--color--warning spc--bottom--sml'
										: 'type--color--success spc--bottom--sml'
								}
							>
								{t(exitScanNotification)}
							</p>
						)}
						{exitScanNotification && exitScanNotification.includes('WARNING') && (
							<button className="btn btn--med btn--primary spc--bottom--sml" type="button" onClick={onDetails}>
								{t('FULFILLMENTORDER.EXITSCANMODE.DETAILS')}
							</button>
						)}
						{fulfillmentOrders && fulfillmentOrders.length != 0 && (
							<div className="container--with-scroll container--with-scroll--modal spc--bottom--sml">
								<BaasicTable
									{...{
										data: fulfillmentOrders.slice(),
										tableData,
										exitScanModeViewStore,
										actions: exitScanModeViewStore,
									}}
								/>
							</div>
						)}
						<ReactTooltip />
					</div>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(ExitScanModeTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/ExitScanModeTemplate.jsx